export const downloadData=[
    {
      url: 'https://tap.cn/odefamCB?channel=rep-rep_n18qc9kvxct',
      iconUrl: require('../src/images/common/taptap-2.png'),
      channel:'taptap'
    },
    {
      url: 'https://www.biligame.com/detail/?id=110999&sourceFrom=9900000011',
      iconUrl: require('../src/images/common/bilibili.png'),
      channel:'bilibili'
    },
    {
      url: 'https://www.3839.com/a/153612.htm',
      iconUrl: require('../src/images/common/hykb.png'),
      channel:'hykb'
    },
    {
      url: 'https://wsy-website.dianchu.com/secret-room/sor3-dc_03037-6467-release.apk',
      iconUrl: require('../src/images/common/azgf.png'),
      channel:'azgf'
    },
  ]